<template>
  <div v-if="value">
    <p
      v-if="value.paragraph"
      :class="pClass ? pClass : value.list && value.list.length ? 'mb-4' : ''"
      :style="pStyle"
    >
      <StyledText :em-class="emClass" :value="value.paragraph" />
    </p>

    <ol
      v-if="value.list && value.list.length && value.list_ordered"
      class="ml-6"
    >
      <li v-for="(item, i) in value.list" :key="i">
        <StyledTextTruncated :em-class="emClass" :value="item" />
      </li>
    </ol>
    <ul
      v-else-if="value.list && value.list.length"
      :class="listClass"
      :style="listStyle"
    >
      <li v-for="(item, i) in value.list" :key="i">
        <StyledTextTruncated :em-class="emClass" :value="item" />
      </li>
    </ul>
  </div>
</template>

<script setup>
defineProps({
  emClass: {
    default: undefined,
    type: String
  },
  pClass: {
    default: undefined,
    type: String
  },
  pStyle: {
    default: undefined,
    type: Object
  },
  listClass: {
    default: 'ml-6',
    type: String
  },
  listStyle: {
    default: undefined,
    type: Object
  },
  value: {
    default: undefined,
    type: Object
  }
})
</script>
